import React, { useMemo, useCallback } from 'react';
import PropTypes from 'prop-types';
import { useSelector } from 'react-redux';
import { Table as TableV5 } from 'antd-v5';
import { safeExtractFromObject } from '../helpers/helpers';

export default function ListView({
  dataSource,
  onClick,
  columns,
  loadingIds,
  clickProps,
  rowSelection,
}) {
  const divisions = useSelector((state) => state.settings.divisions);
  const settings = useSelector((state) => safeExtractFromObject(state, 'settings.company.settings'));
  const hasRedesign = settings?.uxRedesignPt1;

  const dataEntries = useMemo(() => dataSource.map((entry) => ({
    key: entry.id,
    division: divisions[entry.divisionId]?.name,
    isLoading: loadingIds?.has(entry.id),
    ...entry,
  })), [dataSource, divisions, loadingIds]);

  const onHeaderRow = useCallback(() => {
    if (!hasRedesign) return null;
    return {
      className: 'ontraccr-table-header',
    };
  }, [hasRedesign]);

  const selectionProps = useMemo(() => {
    if (!rowSelection) return {};
    return {
      rowSelection: {
        selectedRowKeys: rowSelection.selectedRowKeys,
        onSelect: rowSelection.onSelect,
        onSelectAll: rowSelection.onSelectAll,
        columnWidth: 50,
        fixed: true,
        getCheckboxProps: () => ({
          className: hasRedesign ? 'ontraccr-checkbox' : '',
          disabled: false,
        }),
      },
    };
  }, [rowSelection, hasRedesign]);

  let baseRowClassName = 'listview-table-scroll';
  if (hasRedesign) {
    baseRowClassName += ' listview-table-scroll-redesign';
  }

  const height = useMemo(() => (
    window.innerHeight - 250
  ), []);

  return (
    <TableV5
      virtual
      className="card-grid-table"
      columns={columns}
      dataSource={dataEntries}
      size="small"
      pagination={false}
      onRow={(entry) => ({
        onClick: !entry?.isLoading ? () => onClick(clickProps ? clickProps(entry) : entry) : null,
      })}
      tableLayout="fixed"
      rowClassName={baseRowClassName}
      scroll={{ y: height }}
      onHeaderRow={onHeaderRow}
      // eslint-disable-next-line react/jsx-props-no-spreading
      {...selectionProps}
    />
  );
}

ListView.propTypes = {
  dataSource: PropTypes.arrayOf(PropTypes.shape({
    id: PropTypes.string,
  })).isRequired,
  onClick: PropTypes.func.isRequired,
  columns: PropTypes.arrayOf(PropTypes.shape({})).isRequired,
  loadingIds: PropTypes.instanceOf(Set),
  clickProps: PropTypes.func,
  rowSelection: PropTypes.shape({
    selectedRowKeys: PropTypes.arrayOf(PropTypes.string),
    onSelect: PropTypes.func,
    onSelectAll: PropTypes.func,
  }),
};

ListView.defaultProps = {
  loadingIds: null,
  clickProps: null,
  rowSelection: null,
};
